import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {deleteDrop, getDropById, getUser, markDropUsed} from "../../api.js";
import {BackButton} from "../../shared/BackButton.jsx";
import {formatDate} from "../../services/utils.js";
import {Loading} from "../../shared/Loading.jsx";

export const Drop = ({}) => {

  const [user, setUser] = useState(null)

  useEffect(() => {
    getUser().then((user) => {
      setUser(user)
    }).catch((error) => console.error(error))
  }, []);

  const navigate = useNavigate()
  const [drop, setDrop] = useState({})
  const [loading, setLoading] = useState(true)
  const { id } = useParams();

  const onDeleteDrop = () => {
    if(confirm("Вы Уверены?")){
      deleteDrop(id).then(() => {
        navigate("/")
      })
    }
  }

  const onSellDrop = () => {
    markDropUsed({uuid: id, soldTo: user.user_id}).then(() => {
      fetchDrop();
    })
  }

  const fetchDrop = () => {
    setLoading(true)
    getDropById(id).then((data) => {
      setDrop(data)
      setLoading(false)
    }).catch((error) => {
      console.error(error)
      setLoading(false)
    })
  }

  useEffect(() => {
    fetchDrop()
  }, [id])

  return <div style={{textAlign: "center"}}>
    <h2>Клад</h2>

    <BackButton linkTo="/" />

    {loading ? <Loading /> : (
      drop?.id && <div
            style={{display: "flex", flexDirection: "column", gap: "10px", justifyContent: "center", alignItems: "center"}}>

          <div className="well">
            <p style={{fontSize: '18px', fontWeight: 'bold'}}>Управление:</p>

            {
              drop.sold_at ? <div>Клад продан: {formatDate(drop.sold_at)}</div> : <button onClick={onSellDrop} style={{
                background: "green",
                padding: "12px",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                fontSize: "18px",
                fontWeight: "bold"
              }}>Пометить Проданным
              </button>
            }


            <button onClick={onDeleteDrop} style={{
              background: "red",
              padding: "12px",
              color: "#fff",
              border: "none",
              marginTop: "10px",
              borderRadius: "5px",
              fontSize: "18px",
              fontWeight: "bold"
            }}>Удалить
            </button>
          </div>

          <div className="well">
            <p style={{fontSize: '18px', fontWeight: 'bold'}}>Детали:</p>
            <div>{drop.packages.product.short_description}</div>
            <div>{drop.packages.quantity} {drop.packages.product.measure}</div>
            <div>Comment: {drop.comment}</div>
            <div>{drop.district.city.city}</div>
            <div>{drop.district.district}</div>
            <div>Работа по упаковке:
              {drop.isPackaged === true && "Да"}
              {drop.isPackaged === false && "Нет"}
              {drop.isPackaged === null && "Не указано"}
            </div>
            {drop.dropType && (
              <div>Тип дропа: {drop.dropType === 'magnet' ? 'Магнит' : 'Обычный'}</div>
            )}
            <br/>
            {
              drop.photos.split(",").map(photo => <img style={{width: "50%"}} key={photo} className="mb-2"
                                                       src={`${process.env.REACT_APP_API_URL}/photos/${photo}`}/>)
            }
          </div>
        </div>
    )}

  </div>
}
